import { Button, Checkbox, Input, TimeInput } from "@kart/components";
import { useState } from "react";
import { createNewTrack } from "../utils/track/Track.axios";
import { Track } from "../utils/track/Track.types";
import { generateEmptyTrack } from "../utils/track/Track.utils";

import { toast } from "react-toastify";
import { useAxios } from "../hooks/useAxios";
import { useUser } from "../hooks/useUser";
import { UserRole } from "../utils/User/User.types";

export const CreateTrack = () => {
  const { axios } = useAxios();
  const { user } = useUser();
  const [trackToEdit, setTrackToEdit] = useState<Track>(generateEmptyTrack());

  const update = <K extends keyof Track>(key: K, newValue: Track[K]): void =>
    setTrackToEdit({ ...trackToEdit, [key]: newValue });

  const handleSubmit = (): void => {
    if (!user || !axios) return;
    createNewTrack(axios, { ...trackToEdit, userId: user?.id }).then(
      (createdTrack) => {
        if (createdTrack) {
          toast("Strecke erfolgreich angelegt");
          setTrackToEdit(generateEmptyTrack({ userId: user.id }));
        } else toast("Fehler beim anlegen der Strecke");
      },
    );
  };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <Input
        type="text"
        label="Name"
        onChange={(name) => update("name", name || "")}
        value={trackToEdit.name}
      />
      <Input
        type="text"
        label="Ort"
        onChange={(location) => update("location", location || "")}
        value={trackToEdit.location}
      />
      <Input
        type="number"
        label="Kurven"
        onChange={(turns) => update("turns", Number(turns))}
        value={trackToEdit.turns}
      />
      <TimeInput
        label="BesteZeit"
        ms={trackToEdit.lapRecord}
        onChange={(lapRecord) => update("lapRecord", lapRecord)}
      />
      <TimeInput
        label="Durchschnitt"
        onChange={(average) => update("averageTime", Number(average))}
        ms={trackToEdit.averageTime}
      />
      {user?.role === UserRole.ADMIN && (
        <Checkbox
          onCheck={(official) => update("officialTrack", official)}
          value={trackToEdit.officialTrack}
          label="Offizielle Strecke"
          labelPosition="right"
        />
      )}
      <Button type="submit" label={"Erstellen"} />
    </form>
  );
};
